import { getContract as getContractWagmi } from '@wagmi/core'
import { parseEther } from 'viem'
import config from 'app/configWagmi'
import constants from 'app/constants'
import { getBlockchainErrorStatus } from 'app/util/errorCodes'
import loadAbi from './loadAbi'

/**
 * Mint avatar with wallet provider - note that this is only currently
 * to be used for non-paper based wallets (given paper wallets are
 * required to use the `mintAvatarWithPaper` approach)
 *
 * @param {string} walletAddress - the user wallet address
 * @param {object} submissionData - the compiled checkout data
 * @param {object} walletClient - the wallet client
 * @returns {Promise} resolves on completion
 */
const mintAvatarWithWallet = async (
  walletAddress,
  submissionData,
  walletClient
) => {
  const { accessoryIds, baseIds, total } = submissionData
  const contractInfo = constants.CONTRACTS.AvatarCollection
  const { publicClient } = config
  const abiData = await loadAbi(contractInfo.abiUrl)
  const contract = await getContractWagmi({
    address: contractInfo.address,
    abi: abiData.abi,
    walletClient
  })

  let transactionInfo

  try {
    const value = parseEther(String(total))

    const hash = await contract.write.customisedPublicMint({
      args: [baseIds, accessoryIds, walletAddress],
      value
    })

    transactionInfo = await publicClient.waitForTransactionReceipt({ hash })
  } catch (err) {
    console.error(err)

    return getBlockchainErrorStatus(err)
  }

  const success = transactionInfo?.status === 'success'

  return {
    success,
    data: transactionInfo,
    message: !success && 'Transaction failed.'
  }
}

// Export
export default mintAvatarWithWallet
